import { m } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import { IconButton, Box, Badge } from '@mui/material';
import { badgeClasses } from '@mui/material/Badge';
// hooks
import { doc, getDoc } from 'firebase/firestore';
// routes
import { paths } from 'src/routes/paths';
// auth
import { useAuthContext } from 'src/auth/hooks';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { getStatistic } from 'src/redux/slices/statistic';
// components
import { varHover } from 'src/components/animate';
import Iconify from 'src/components/iconify';
import Label from 'src/components/label';
//
import { db } from 'src/auth/context/jwt/firebase';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function Stats() {
  const { user } = useAuthContext();

  const navigate = useNavigate();

  // const [stats, setStats] = useState(null);

  const { value: statistic } = useSelector((state) => state.statistic);

  const { value } = useSelector((state) => state.statistic);

  const dispatch = useDispatch();

  // const fetchStats = async (uid) => {
  //   const statsRef = doc(db, 'users', uid);

  //   try {
  //     const snap = await getDoc(statsRef);

  //     if (snap.exists()) {
  //       setStats(snap.data().stats);
  //     }

  //     // return snap.data().stats || null;
  //   } catch (err) {
  //     console.error('Failed to fetch stats:', err);
  //     // return null;
  //   }
  // };

  useEffect(() => {
    if (user.uid) dispatch(getStatistic({ uid: user.uid }));
    // if (user.uid) fetchStats(user.uid);
  }, [user, dispatch]);

  const getUTCDateString = (date) => date.toISOString().split('T')[0];

  const today = getUTCDateString(new Date());
  const hasWonToday = statistic?.lastWinDate === today;

  if (!statistic) return null;

  return (
    <>
      {/* {stats.currentWinStreak > 1 && (
        <Label color="default">Current Win Streak {stats.currentWinStreak}</Label>
      )} */}
      <Box
        component={m.div}
        transition={{
          duration: 12,
          ease: 'linear',
          repeat: Infinity,
        }}
      >
        <IconButton
          component={m.button}
          whileTap="tap"
          whileHover="hover"
          variants={varHover(1.05)}
          aria-label="streak"
          onClick={() =>
            window.location.pathname.includes('statistics')
              ? navigate(paths.home)
              : navigate(paths.statistic)
          }
          // onClick={settings.onToggle}
          sx={{
            width: 40,
            height: 40,
            position: 'relative', // Needed for the badge positioning
          }}
        >
          {/* Streak Icon */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              borderRadius: '50%',
              width: 24,
              height: 24,
            }}
          >
            <Iconify
              icon="fluent-emoji-flat:fire"
              width={24}
              style={{ filter: hasWonToday ? 'none' : 'grayscale(100%)' }}
            />

            {statistic.currentStreak > 0 && (
              <Box
                sx={{
                  position: 'absolute',
                  bottom: -4,
                  right: -4,
                  backgroundColor: 'warning.darker',
                  borderRadius: '50%',
                  padding: '2px 4px',
                  fontSize: 10,
                  color: 'white',
                  fontWeight: 'bold',
                }}
              >
                {statistic.currentStreak}
              </Box>
            )}
          </Box>
        </IconButton>
      </Box>
    </>
  );
}
